Ext.define('SA.BootErrorObserver', {
    singleton: true,

    create(callback) {
        return SA.CompositeObserver.create(callback)
            .addDomEvent(window, 'error')
            .addDomEvent(window, 'unhandledrejection')
            .addExtEvent(SA.data.LocationsCache, 'missingEntities')
            .addExtEvent(SA.data.AttributesCache, 'missingEntities');
    }
});